import * as React from 'react'
import type { Toast } from 'react-hot-toast'

export const ToastContext = React.createContext<Pick<
  Toast,
  'type' | 'id' | 'message'
> | null>(null)

export const useToastContext = () => {
  const context = React.useContext(ToastContext)

  if (!context) {
    throw new Error('useToastContext must be used within a ToastProvider')
  }

  return context
}
